import { React } from 'react';

const Prev = () => {
    return (
        <svg width="64" height="64" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_53_45)">
<circle cx="37" cy="35" r="31.5" stroke="#85B9E9" strokeWidth="3"/>
<path d="M55.4375 32.4304H25.0462L34.3481 21.22C34.7831 20.6949 34.9923 20.018 34.9299 19.3381C34.8674 18.6582 34.5383 18.031 34.015 17.5946C33.4917 17.1582 32.817 16.9482 32.1394 17.0109C31.4619 17.0736 30.8368 17.4038 30.4019 17.9289L17.5894 33.356C17.5032 33.4787 17.4261 33.6077 17.3587 33.7417C17.3587 33.8703 17.3588 33.9474 17.1794 34.076C17.0632 34.3708 17.0024 34.6846 17 35.0016C17.0024 35.3186 17.0632 35.6324 17.1794 35.9272C17.1794 36.0558 17.1794 36.1329 17.3587 36.2615C17.4261 36.3956 17.5032 36.5245 17.5894 36.6472L30.4019 52.0744C30.6428 52.3646 30.9445 52.598 31.2855 52.758C31.6266 52.918 31.9985 53.0006 32.375 53C32.9737 53.0012 33.554 52.7919 34.015 52.4086C34.2745 52.1928 34.489 51.9277 34.6462 51.6285C34.8034 51.3294 34.9002 51.002 34.9312 50.6653C34.9621 50.3285 34.9266 49.9889 34.8265 49.666C34.7265 49.343 34.5639 49.043 34.3481 48.7832L25.0462 37.5728H55.4375C56.1171 37.5728 56.7689 37.3019 57.2495 36.8197C57.73 36.3375 58 35.6835 58 35.0016C58 34.3197 57.73 33.6657 57.2495 33.1835C56.7689 32.7013 56.1171 32.4304 55.4375 32.4304Z" fill="#85B9E9"/>
</g>
<defs>
<filter id="filter0_d_53_45" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_45"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_45" result="shape"/>
</filter>
</defs>
</svg>

    )
}

export default Prev